<template>
  <div class="edit-base-shelf-item">
    <div class="edit-shelfname-label">显示功能<i class="vip">VIP</i></div>
    <div class="uploading" @click="showButtonSetting()">设置</div>
    <button-set :current-module="type" ref="buttonSet"></button-set>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>
<script>
import TipDialog from '@components/common/TipDialog.vue'
import compareVipRight from '@components/common/compareVipRight.js'
import ButtonSet from '@components/editDrawer/edit/ButtonSet'
export default {
  name: 'shelfLibButtonDisplay',
  data() {
    return {}
  },
  mixins: [compareVipRight],
  computed: {
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  methods: {
    showButtonSetting() {
      if (this.compare({ type: 'boole', key: 'displaySet' })) {
        this.$refs.buttonSet.dialogVisible = true
      } else {
        this.$refs.memberDialog.visible = true
      }
    }
  },
  components: {
    ButtonSet,
    TipDialog
  },
  props: {
    type: String
  }
}
</script>
<style lang="scss" scoped>
.edit-base-shelf-item {
  display: flex;
}
.edit-shelfname-label {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  padding-bottom: 0 !important;
  img {
    height: 24px;
    margin-left: 2px;
  }
  i {
    width: 30px;
    line-height: 20px;
    background: #df5813;
    text-align: center;
    color: #fff;
    font-size: 10px;
    margin-left: 5px;
    border-radius: 2px;
    font-style: normal;
    font-weight: bold;
  }
}
.uploading {
  height: 100%;
  background: #df5813;
  color: #fff;
  border-radius: 15px;
  border: none;
  width: 55px;
  margin-left: 8px;
  text-align: center;
  cursor: pointer;
}
</style>
